/**
 * Null-safe equality check for user IDs across the API/identity boundary.
 *
 * The API returns numeric user IDs while Cognito stores them as strings.
 * This helper normalizes both sides to string before comparing, so
 * `isSameUserId(123, "123")` returns `true`.
 *
 * Returns `false` if either argument is `null` or `undefined` — two
 * missing IDs are never considered equal.
 */
export function isSameUserId(
  a: string | number | null | undefined,
  b: string | number | null | undefined
): boolean {
  if (a == null || b == null) {
    return false;
  }

  return String(a) === String(b);
}
